import * as service from './service'
export default {
  namespace: 'recommendUserUserRewardRecord',
  state: {
    demoData: {}
  },
  effects: {
    * findAwardPage ({ payload }, { call, put }) {
      const res = yield call(service.findAwardPage, payload)
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
